import { render, staticRenderFns } from "./NewsCategoryList.vue?vue&type=template&id=7b03c8ca&"
import script from "./NewsCategoryList.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./NewsCategoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports